import LegalPageLayout from './LegalPageLayout'

/** A caixa de ideia do Rogério saiu da landing em 18/09/2026; a seção sobre ela só aparece se a experiência voltar. */
export default function TermsPage({ rogerioEnabled = false }: { rogerioEnabled?: boolean } = {}) {
  return (
    <LegalPageLayout eyebrow="Termos" title="Termos de Uso" updated="25 de setembro de 2026">
      <p className="legal-page__intro">
        Estes termos descrevem o uso do site da Oficina IA.
      </p>

      <section aria-labelledby="terms-page-purpose">
        <h2 id="terms-page-purpose">Finalidade da página</h2>
        <p>
          A landing apresenta formas de aprender usos práticos de inteligência artificial. O canal da Oficina IA
          no YouTube é gratuito e não há promessa de frequência, calendário ou sequência de publicação.
        </p>
      </section>

      {rogerioEnabled && <section aria-labelledby="terms-page-rogerio">
        <h2 id="terms-page-rogerio">Ideias e guias do Rogério</h2>
        <p>O Rogério oferece sugestões e um guia para você começar, gratuitamente e sem cadastro.
          Ele não executa tarefas no seu computador nem acompanha a execução. Você escolhe o caminho,
          adapta a mensagem e confere o resultado na ferramenta que decidir usar.</p>
        <p>As respostas combinam IA e conteúdo predefinido e podem conter erros ou não atender ao seu caso.
          Não há garantia de resultado ou economia. Confira as informações antes de usar ou compartilhar,
          inclusive nos PDFs.</p>
        <p>Há limites de uso para manter o serviço disponível. Em momentos de excesso de pedidos ou
          indisponibilidade, pode ser necessário esperar e tentar novamente. Os guias já abertos continuam
          disponíveis neste navegador enquanto a experiência estiver salva.</p>
      </section>}

      <section aria-labelledby="terms-page-individual">
        <h2 id="terms-page-individual">Acompanhamento individual</h2>
        <p>
          O primeiro passo é marcar a primeira conversa, gratuita, de 30 minutos na página de reservas de Arthur no Google Agenda,
          ou, se preferir, tirar dúvidas antes pelo WhatsApp. A primeira conversa serve para entender a necessidade e
          descobrir como usar IA no caso da pessoa. O acompanhamento pago tem 9 horas, além da conversa gratuita, distribuídas de 1 a 2 horas por semana,
          por videochamada. O valor e a distribuição das horas são combinados na conversa. Marcar a primeira conversa não é contratação nem pagamento.
        </p>
        <p>O acompanhamento inclui dúvidas pelo WhatsApp entre os encontros. Qualquer material enviado por Arthur
          é do aluno. As aulas não são gravadas; são transcritas somente com a permissão do participante.
          As assinaturas de ferramentas ficam por conta do participante.</p>
      </section>

      <section aria-labelledby="terms-page-responsibility">
        <h2 id="terms-page-responsibility">Uso do conteúdo</h2>
        <p>
          O conteúdo tem finalidade educacional. Resultados produzidos com inteligência artificial podem conter
          erros e precisam ser conferidos antes de serem usados, especialmente em decisões de maior impacto.
        </p>
      </section>

      <section aria-labelledby="terms-page-contact">
        <h2 id="terms-page-contact">Contato</h2>
        <p>Para tirar uma dúvida sobre estes termos, use o link Falar com Arthur no rodapé.</p>
      </section>
    </LegalPageLayout>
  )
}
